import { render, staticRenderFns } from "./addTaskScheduleComp.vue?vue&type=template&id=3c0b4ca2&scoped=true&"
import script from "./addTaskScheduleComp.vue?vue&type=script&lang=js&"
export * from "./addTaskScheduleComp.vue?vue&type=script&lang=js&"
import style0 from "./addTaskScheduleComp.vue?vue&type=style&index=0&id=3c0b4ca2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0b4ca2",
  null
  
)

export default component.exports